import { createSlice } from '@reduxjs/toolkit'

interface MapSlice {
  filterMountpoints: number[]
}

const mapSlice = createSlice({
  name: 'map',
  initialState: { filterMountpoints: [] } as MapSlice,
  reducers: {
    filterMountpoints: (state, action) => {
      state.filterMountpoints = action.payload
    },
  },
})

export default mapSlice.reducer
export const { filterMountpoints } = mapSlice.actions
